import type { ConfigType } from '@plone/registry';

export default function install(config: ConfigType) {
  config.settings.DSGVOBanner.showBanner = false;
  return config;
}
